import { Modal } from "bootstrap";
export class BootstrapHelper{

    static modalTriggerActiveClass = "--active";

    static init(){
        this.collapseAlternativeText();
        this.enhanceModals();
    }
    static collapseAlternativeText(){
        let labelSelectors = `[class*=__label]`;

        document.querySelectorAll(".accordion-collapse").forEach( element => {
            element.addEventListener("show.bs.collapse", (event) => {
                document.querySelectorAll( `[data-bs-target="#${event.target.id}"]`).forEach( (element) => {
                    if( element.dataset.labelClass !== undefined ){labelSelectors = element.dataset.labelClass;}
                    if( element.dataset.expandedLabel !== undefined ){
                        element.querySelector(labelSelectors).textContent = element.dataset.expandedLabel;
                    }
                });
            });
            element.addEventListener("hide.bs.collapse", (event) => {
                document.querySelectorAll(`[data-bs-target="#${event.target.id}"]`).forEach( (element) => {
                    if( element.dataset.labelClass !== undefined ){labelSelectors = element.dataset.labelClass;}
                    if( element.dataset.collapsedLabel !== undefined ){
                        element.querySelector(labelSelectors).textContent = element.dataset.collapsedLabel;
                    }
                })
            });
        });
    }
    static enhanceModals(){
        
        document.addEventListener("click", (event) => {
            if( event.target.matches("[data-click-behaviour]") ){
                switch( event.target.getAttribute('data-click-behaviour') ){
                    case "hide-on-click":
                        Modal.getInstance(event.target.closest(".modal")).hide();
                    break;
                }
            }
        });

        document.querySelectorAll(".modal").forEach( element => {
            element.addEventListener("show.bs.modal", (e) => {
                //Icons support
                var trigger = e.relatedTarget;
                element.triggerElement = trigger;
                trigger.classList.add(this.modalTriggerActiveClass);
                if( trigger.getAttribute("data-icon-switch") !== null && trigger.querySelector("[data-js-component=Icon]") ){
                    if( typeof trigger.querySelector("[data-js-component=Icon]").instance.changeIcon == "function" ){
                        var iconSwitchConfig = JSON.parse(trigger.getAttribute("data-icon-switch"));
                        trigger.querySelector("[data-js-component=Icon]").instance.iconSwitch(iconSwitchConfig);
                    }
                }
                if( trigger.getAttribute("data-class-switch") !== null  ){
                    var classSwitchConfig = JSON.parse(trigger.getAttribute("data-class-switch"));
                    trigger.classList.remove(classSwitchConfig.idle);
                    trigger.classList.add(classSwitchConfig.active);
                }
            });
            element.addEventListener("hide.bs.modal", (e) => {
                var trigger = e.target.triggerElement;
                e.target.triggerElement.classList.remove(this.modalTriggerActiveClass);
                if( e.target.triggerElement.getAttribute("data-icon-switch") !== null && e.target.triggerElement.querySelector("[data-js-component=Icon]") ){
                    if( typeof e.target.triggerElement.querySelector("[data-js-component=Icon]").instance.changeIcon == "function" ){
                        var iconSwitchConfig = JSON.parse(e.target.triggerElement.getAttribute("data-icon-switch"));
                        e.target.triggerElement.querySelector("[data-js-component=Icon]").instance.iconSwitch(iconSwitchConfig);
                    }
                }
                if( trigger.getAttribute("data-class-switch") !== null  ){
                    var classSwitchConfig = JSON.parse(trigger.getAttribute("data-class-switch"));
                    trigger.classList.remove(classSwitchConfig.active);
                    trigger.classList.add(classSwitchConfig.idle);
                }
            });
        });
    }

}